import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";

// Source: https://fonts.google.com/icons?icon.query=dock&selected=Material+Symbols+Rounded:dock_to_bottom:FILL@0;wght@300;GRAD@0;opsz@24&icon.size=24&icon.color=%23e3e3e3&icon.style=Rounded
export const DockToBottomIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Dock To Bottom Icon</title>;
    t1 = <path d="M5.58276 19.9C5.17342 19.9 4.82392 19.7552 4.53426 19.4657C4.24476 19.1761 4.10001 18.8266 4.10001 18.4172V5.58273C4.10001 5.17339 4.24476 4.82389 4.53426 4.53423C4.82392 4.24473 5.17342 4.09998 5.58276 4.09998H18.4173C18.8266 4.09998 19.1761 4.24473 19.4658 4.53423C19.7553 4.82389 19.9 5.17339 19.9 5.58273V18.4172C19.9 18.8266 19.7553 19.1761 19.4658 19.4657C19.1761 19.7552 18.8266 19.9 18.4173 19.9H5.58276ZM5.40001 15.6V18.2922C5.40001 18.3692 5.43209 18.4397 5.49626 18.5037C5.56026 18.5679 5.63076 18.6 5.70776 18.6H18.2923C18.3693 18.6 18.4398 18.5679 18.5038 18.5037C18.5679 18.4397 18.6 18.3692 18.6 18.2922V15.6H5.40001ZM5.40001 14.3H18.6V5.70773C18.6 5.63073 18.5679 5.56023 18.5038 5.49622C18.4398 5.43206 18.3693 5.39998 18.2923 5.39998H5.70776C5.63076 5.39998 5.56026 5.43206 5.49626 5.49622C5.43209 5.56023 5.40001 5.63073 5.40001 5.70773V14.3Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};